export interface EvaluationData {
  id?: number;
  type?: string;
  title?: string;
  description?: string;

  translations?: any;
}

export class Evaluation {
  public static getNonTranslatableFields(): string[] { return ['id', 'type']; }
  public static getTranslatableFields(): string[] { return ['title', 'description']; }
  public static getFields(): string[] { return ['id', 'type', 'title', 'description']; }
  public static getKeyFields(): string[] { return ['id']; }

  id?: number;
  type?: string;
  title?: string;
  description?: string;

  translations?: any;

  public static fromAPI(data: EvaluationData): Evaluation {
    let translationData: any = {};
    if (data.translations) {
      for (let i = 0; i < data.translations?.length; i++) {
        if (data.translations[i]['evaluationId'] === data['id']) {
          translationData = data.translations[i];
          i = data.translations?.length;
        }
      }
    }
    return new Evaluation({
      id: data.id,
      type: data.type,
      title: translationData.title ?? data.title,
      description: translationData.description ?? data.description,
      translations: data.translations,
    });
  }

  public static fromAPIList(data: EvaluationData[]): Evaluation[] {
    return data.map((item: EvaluationData) => Evaluation.fromAPI(item));
  }

  constructor({id, type, title, description, translations} : EvaluationData) {
    this.id = id;
    this.type = type;
    this.title = title;
    this.description = description;
    this.translations = translations;
  }

  public toJson(): EvaluationData {
    return {
      id: this.id,
      type: this.type,
      title: this.title,
      description: this.description,
    };
  }
}
